export const Empty = props => null;
